import { Colors } from "../../../ui";
import { TextAlignment } from "../../canvas/entities/TextConventions";
import { FieldLayout } from "../../canvas/fields/AdaptableField";
import { SimpleTextField } from "../../canvas/fields/SimpleTextField";
import { CardPile } from "./CardPile";

export class CardPileLabel extends SimpleTextField {

    public readonly fontFamily: string = 'Rubik';
    public readonly fontColor: string = Colors.textLighter;
    public readonly fontSize: number = 0;
    public readonly fontWeight: number = 500;
    public readonly lineHeight: number = 1.25;
    public readonly textMargin: number | number[] = 5;
    public readonly textAlignH = TextAlignment.middle;
    public readonly textAlignV = TextAlignment.middle;

    public get default() {
        return true;
    }

    public get layout(): FieldLayout {
        return new FieldLayout(this.owner.cast(CardPile).layout.label, 2);
    }
}